import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Spinner({ className }: { className?: string }): JSX.Element {
  return <Loader2 className={cn('h-4 w-4 animate-spin', className)} aria-hidden />;
}

export function FullPageSpinner(): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center" role="status" aria-live="polite">
      <Spinner className="h-8 w-8 text-brand-600" />
      <span className="sr-only">Loading</span>
    </div>
  );
}

export function SectionSpinner({ className }: { className?: string }): JSX.Element {
  return (
    <div className={cn('flex items-center justify-center py-12', className)} role="status">
      <Spinner className="h-6 w-6 text-brand-600" />
    </div>
  );
}
